import { City } from '../../models';
import { Category } from '../../models/categories';
import { FooterProps } from '../../models/footer';
import { http } from '../api/http';
import { CITIES_API_LIMIT } from '../consts';

export function getCities() {
  return http.get<{ results: City[] }>(`${window.location.origin}/api/cities`, {
    limit: CITIES_API_LIMIT,
  });
}

export function getPageBlocks(cityId: number) {
  return http.get<{
    categoriesForHeader: Category[];
    footerProps: FooterProps;
  }>(`${window.location.origin}/api/${cityId}/page-blocks`);
}
